import { ConsultantEditorStore } from "../../ConsultantEditorStore";
import {
  ExpertiseProfessionStore,
  ExpertiseProfession
} from "../ExpertiseProfessionStore";
import { Professions } from "@bonliva-crm/shared";

export interface TeacherProfession extends ExpertiseProfession {
  areasOfExpertise: AreaOfExpertise[];
}

export interface AreaOfExpertise {
  name: string;
  certifiedFrom?: string;
  selected: boolean;
  specializations: Specialization[];
}

export interface Specialization {
  name: string;
  qualified: boolean;
  interestedIn: boolean;
  experience: string;
}

export class TeacherStore extends ExpertiseProfessionStore<TeacherProfession> {
  constructor(storeIndex: number, public editorStore: ConsultantEditorStore) {
    super(Professions.SE_LARARE, storeIndex, editorStore);
  }

  get areasOfExpertise(): AreaOfExpertise[] {
    return this.currentExpertiseProfession.areasOfExpertise;
  }

  initForm() {
    if (!this.currentExpertiseProfession) {
      const value = {
        professionName: this.profession,
        areasOfExpertise: this.editorStore
          .getAOEsOnProfession(this.profession)
          .map((x) => ({
            name: x,
            certifiedFrom: "",
            selected: false,
            specializations: this.editorStore
              .getSpecialization(x, this.profession)
              .map((y) => ({
                name: y,
                experience: "",
                interestedIn: false,
                qualified: true
              }))
          })),
        certifiedFrom: "",
        systems: [],
        digitalCompetence: [],
        schoolPlatforms: []
      };

      this.editorStore.form.setValue(`professions.${this.storeIndex}`, value);
    }
  }

  get schoolPlatforms(): string[] {
    return [];
  }

  get digitalCompetence(): string[] {
    return [];
  }
}
